// extracted by mini-css-extract-plugin
module.exports = {"snippet":"Snippet_snippet__3rVbT","margin":"Snippet_margin__1WFPn","code":"Snippet_code__1pxhF","preview":"Snippet_preview__2YynJ"};